/** MIME + extension allowlist for product catalog source uploads. */

export const PRODUCT_SOURCE_XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
export const PRODUCT_SOURCE_XLSM_MIME =
  'application/vnd.ms-excel.sheet.macroEnabled.12'

export const PRODUCT_SOURCE_FILE_ACCEPT =
  'application/pdf,image/jpeg,image/png,' +
  `${PRODUCT_SOURCE_XLSX_MIME},${PRODUCT_SOURCE_XLSM_MIME},` +
  '.pdf,.jpg,.jpeg,.png,.xlsx,.xlsm'

export function isAllowedProductSourceFile(file: File): boolean {
  const lowerCaseFileName = file.name.toLowerCase()
  return (
    file.type === 'application/pdf' ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === PRODUCT_SOURCE_XLSX_MIME ||
    file.type === PRODUCT_SOURCE_XLSM_MIME ||
    lowerCaseFileName.endsWith('.pdf') ||
    lowerCaseFileName.endsWith('.jpg') ||
    lowerCaseFileName.endsWith('.jpeg') ||
    lowerCaseFileName.endsWith('.png') ||
    lowerCaseFileName.endsWith('.xlsx') ||
    lowerCaseFileName.endsWith('.xlsm')
  )
}

/** Prefer browser MIME; fall back from extension when the browser leaves type empty. */
export function resolveProductSourceContentType(file: File): string {
  if (file.type) {
    return file.type
  }
  const lowerCaseFileName = file.name.toLowerCase()
  if (lowerCaseFileName.endsWith('.xlsx')) {
    return PRODUCT_SOURCE_XLSX_MIME
  }
  if (lowerCaseFileName.endsWith('.xlsm')) {
    return PRODUCT_SOURCE_XLSM_MIME
  }
  if (lowerCaseFileName.endsWith('.png')) {
    return 'image/png'
  }
  if (
    lowerCaseFileName.endsWith('.jpg') ||
    lowerCaseFileName.endsWith('.jpeg')
  ) {
    return 'image/jpeg'
  }
  return 'application/pdf'
}
